import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-preview-image-dialog',
  templateUrl: './preview-image-dialog.component.html',
})
export class PreviewImageDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) readonly imageSrc: string) {}
}
